
import Vue from 'vue';

import ToastForm from '@/components/Toasts/ToastForm.vue';
import ToastTable from '@/components/Toasts/ToastTable.vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
    components: {
        ToastTable,
        ToastForm,
    },
    computed: {
        ...mapState('toasts', ['toasts', 'toastsLoading']),
    },
    data() {
        return {
            title: '',
            dates: [] as Array<string>,
            toastObject: {},
            search: '',
            toastFormOpen: false,
            formMode: 'add',
            toastType: {},
            typeList: [
                {
                    name: 'Service Info', value: 'info', icon: 'info', style: 'blue',
                },
                {
                    name: 'General Note', value: 'star', icon: 'star', style: 'gray',
                },
                {
                    name: 'Health message', value: 'health-warning', icon: 'masks', style: 'green',
                },
            ]as Array<any>,
        };
    },
    methods: {
        ...mapActions('toasts', ['getToasts']),
        addNewToast() {
            this.toastFormOpen = true;
            this.formMode = 'add';
            this.title = 'Create new Toast';
            this.dates = [] as Array<string>;
            this.toastType = {};
            this.dates[0] = new Date().toISOString().substr(0, 10);
            this.dates[1] = new Date().toISOString().substr(0, 10);
            this.toastObject = {};
        },
        async openForm(toastObjectToEdit: any) {
            this.toastFormOpen = true;
            this.formMode = 'edit';
            this.title = 'Edit Toast';
            this.dates = [] as Array<string>;
            this.toastType = {};
            this.dates[0] = toastObjectToEdit.activeSince;
            this.dates[1] = toastObjectToEdit.activeUntil;
            this.toastObject = toastObjectToEdit;
            this.getTypeFromList(toastObjectToEdit.style);
        },
        closedForm() {
            this.getToasts();
        },

        getTypeFromList(color: string) {
            // color = !color ? 'gray' : color;
            this.typeList.forEach((element) => {
                if (element.style === color) {
                    this.toastType = element;
                }
            });
        },
    },

    created() {
        this.getToasts();
    },

});
